// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.dialog-title {
   display: flex;
   justify-content: space-between;
   align-items: center;
}

.mat-dialog-actions {
   justify-content: flex-end;
}
`, "",{"version":3,"sources":["webpack://./src/app/dms/annotation-controller/insert-merge-files/insert-merge-files.component.css"],"names":[],"mappings":"AAAA;GACG,aAAa;GACb,8BAA8B;GAC9B,mBAAmB;AACtB;;AAEA;GACG,yBAAyB;AAC5B","sourcesContent":[".dialog-title {\n   display: flex;\n   justify-content: space-between;\n   align-items: center;\n}\n\n.mat-dialog-actions {\n   justify-content: flex-end;\n}\n"],"sourceRoot":""}]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
